/* * @Author: Wei Guojun * @Date: 2021-04-09 10:11:23 * @Last Modified by: Wei
Guojun * @Last Modified time: 2021-12-29 14:32:21 */
<template>
  <div class="home">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <div class="model sender">
        <el-row class="_header">
          <el-col class="left" :span="10">
            <img src="@/assets/images/icon_ji.png" alt />寄件人信息
          </el-col>
          <el-col class="right" :span="12">
            <img src="@/assets/images/add.png" alt />
            <a @click="selectAddress('send')" href="javascript:void(0)"
              >选择寄件人</a
            >
          </el-col>
        </el-row>
        <div class="from">
          <el-row>
            <el-col class="title" :span="2">
              <div>一键粘贴</div>
            </el-col>
            <el-col :span="19">
              <div>
                <el-input
                  placeholder="示例： 张三 18888888888 上海 上海市 黄浦区 延安东路888号88室 "
                  v-model="ruleForm.send.analysis"
                  clearable
                  @input="doAnalysis(ruleForm.send.analysis, 'send')"
                >
                </el-input>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <div>
                <el-row>
                  <el-col class="title" :span="4">
                    <div>姓名</div>
                  </el-col>
                  <el-col class="input" :span="20">
                    <el-form-item style="margin-left: 0" prop="send.name">
                      <el-autocomplete
                        placeholder="请输入姓名"
                        suffix-icon="el-icon-user"
                        v-model="ruleForm.send.name"
                        @change="idChecked"
                        clearable
                        :fetch-suggestions="
                          (queryString, cb) => {
                            querySearch(queryString, cb, 1)
                          }
                        "
                        :trigger-on-focus="false"
                        @select="
                          (item) => {
                            handleSelect(item, 'send')
                          }
                        "
                      ></el-autocomplete>
                      <span class="span">*</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="11">
              <div>
                <el-row>
                  <el-col class="title" :span="3">
                    <div>联系方式</div>
                  </el-col>
                  <el-col class="input" :span="21">
                    <div>
                      <el-form-item prop="send.phone">
                        <el-input
                          type="text"
                          placeholder="请输入联系手机或电话"
                          v-model.trim="ruleForm.send.phone"
                          suffix-icon="el-icon-phone-outline"
                          @change="idChecked"
                          clearable
                        ></el-input>
                        <span class="span">*</span>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <div>
                <el-row>
                  <el-col class="title" :span="4">
                    <div>省/市/区</div>
                  </el-col>
                  <el-col class="input" :span="20">
                    <div>
                      <el-form-item prop="send.pca">
                        <el-cascader
                          @blur="checkDizhi"
                          @change="changeAddress('send')"
                          ref="send"
                          :options="sender_address"
                          v-model="ruleForm.send.pca"
                          placeholder="请选择省/市/区"
                          filterable
                        ></el-cascader>
                        <span class="span">*</span>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="11">
              <div style="position:relative">
                <el-row>
                  <el-col class="title" :span="3">
                    <div>详细地址</div>
                  </el-col>
                  <el-col class="input" :span="21">
                    <div>
                      <el-form-item prop="send.address">
                        <el-input
                          type="text"
                          @blur="checkDizhi"
                          placeholder="请输入详细地址"
                          suffix-icon="el-icon-map-location"
                          v-model.trim="ruleForm.send.address"
                          clearable
                        ></el-input>
                        <span class="span">*</span>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-button type="text" class="inputClear" @click="inputClear('send')">一键清空</el-button>
              </div>
            </el-col>
          </el-row>
          <!-- <div class="checkbox">
            <el-checkbox v-model="ruleForm.send.save_info" label="保存到我的寄件人" name="type"></el-checkbox>
          </div> -->
          <el-row>
            <el-col :span="11">
              <div>
                <el-row>
                  <el-col class="title" :span="4">
                    <div>实名认证</div>
                  </el-col>
                  <el-col class="input" :span="19">
                    <div @click="dialogFormVisible = true" class="realBox">
                      <span v-if="realFlag">已实名/{{ realForm.name }}</span>
                      <span v-else>未实名</span>
                    </div>
                  </el-col>
                  <el-col :span="1"
                    ><span
                      style="line-height: 40px; color: red; padding-left: 10px"
                      >*</span
                    ></el-col
                  >
                </el-row>
              </div>
            </el-col>
            <el-col :span="11"></el-col>
          </el-row>
        </div>
      </div>
      <div class="model addressee">
        <el-row class="_header">
          <el-col class="left" :span="10">
            <img src="@/assets/images/icon_show.png" alt />收件人信息
          </el-col>
          <el-col class="right" :span="12">
            <img src="@/assets/images/add.png" alt />
            <a @click="selectAddress('collect')" href="javascript:void(0)"
              >添加收件人</a
            >
          </el-col>
        </el-row>
        <div class="from">
          <div class="collectBox">
            <el-row>
              <el-col class="title" :span="2">
                <div>一键粘贴</div>
              </el-col>
              <el-col :span="19">
                <div class="flexBetween">
                  <el-input
                    placeholder="示例： 张三 18888888888 上海 上海市 黄浦区 延安东路888号88室 "
                    v-model="ruleForm.collect.analysis"
                    @input="doAnalysis(ruleForm.collect.analysis, 'collect')"
                    clearable
                  >
                  </el-input>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="11">
                <div>
                  <el-row>
                    <el-col class="title" :span="4">
                      <div>收件人姓名</div>
                    </el-col>
                    <el-col class="input" :span="20">
                      <div>
                        <el-form-item prop="collect.name">
                          <el-autocomplete
                            placeholder="请输入姓名"
                            suffix-icon="el-icon-user"
                            v-model="ruleForm.collect.name"
                            clearable
                            :fetch-suggestions="
                              (queryString, cb) => {
                                querySearch(queryString, cb, 0)
                              }
                            "
                            :trigger-on-focus="false"
                            @select="
                              (item) => {
                                handleSelect(item, 'collect')
                              }
                            "
                          ></el-autocomplete>
                          <span class="span">*</span>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
              <el-col :span="11">
                <div>
                  <el-row>
                    <el-col class="title" :span="3">
                      <div>联系方式</div>
                    </el-col>
                    <el-col class="input" :span="21">
                      <div>
                        <el-form-item prop="collect.phone">
                          <el-input
                            type="text"
                            placeholder="请输入联系手机或电话"
                            v-model.trim="ruleForm.collect.phone"
                            suffix-icon="el-icon-phone-outline"
                            clearable
                          ></el-input>
                          <span class="span">*</span>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 15px">
              <el-col :span="11">
                <div>
                  <el-row>
                    <el-col class="title" :span="4">
                      <div>省/市/区</div>
                    </el-col>
                    <el-col class="input" :span="20">
                      <div>
                        <el-form-item prop="collect.pca">
                          <el-cascader
                            @change="changeAddress('collect')"
                            @blur="checkDizhi"
                            ref="collect"
                            :options="sender_address"
                            v-model="ruleForm.collect.pca"
                            placeholder="请选择省/市/区"
                            filterable
                          ></el-cascader>
                          <span class="span">*</span>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
              <el-col :span="11">
                <div style="position:relative">
                  <el-row >
                    <el-col class="title" :span="3">
                      <div>详细地址</div>
                    </el-col>
                    <el-col class="input" :span="21">
                      <div>
                        <el-form-item prop="collect.address">
                          <el-input
                            type="text"
                            @blur="checkDizhi"
                            placeholder="请输入详细地址"
                            suffix-icon="el-icon-map-location"
                            v-model.trim="ruleForm.collect.address"
                            clearable
                          ></el-input>
                          <span class="span">*</span>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-button type="text" class="inputClear" @click="inputClear('collect')">一键清空</el-button>
                </div>
              </el-col>
            </el-row>
            <el-row v-show="addressClose">
              <el-col :span="11">
                <div>
                  <el-row>
                    <el-col class="title" :span="4"> </el-col>
                    <el-col class="input" :span="20" style="color: red">
                      * 此地址暂时存在“网点停发”情况
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="model other">
        <div class="from">
          <el-row>
            <el-col class="title" :span="2">
              <div>物品类型</div>
            </el-col>
            <el-col class="input" :span="6">
              <div>
                <el-form-item>
                  <el-input
                    class="goods-input"
                    v-model="typeContent"
                    @focus="showGoodsPicker = true"
                  />
                  <span class="span">*</span>
                </el-form-item>
              </div>
            </el-col>
            <el-col class="title" :span="2" v-if="addConfig">
              <div>付款方式</div>
            </el-col>
            <el-col class="input" :span="6" v-if="addConfig">
              <div>
                <el-form-item>
                  <el-select
                    v-model="maiServe"
                    placeholder="请选择付款方式"
                    style="width: 90%"
                    @focus="getdfAuth"
                    @change="serveChoose"
                  >
                    <el-option
                      v-for="item in addserve"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="8" v-if="maiServe == 'topay' ? false : true">
              <div>
                <el-row>
                  <el-col class="title" :span="4">
                    <div>寄付运费</div>
                  </el-col>
                  <el-col class="input" :span="18">
                    <div>
                      <el-form-item>
                        <el-input
                          type="text"
                          placeholder="请输入"
                          v-model.trim="daofu_amount"
                          @input="moneyInput"
                          @blur="moenyBlur"
                          clearable
                        >
                          <template slot="append">元</template></el-input
                        >
                      </el-form-item>
                    </div>
                    <font>非必填，请由业务员输入，运费将打印在面单上</font>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
          <el-row style="padding-top: 20px;padding-bottom: 10px;">
            <el-col class="title" :span="2">
              <div>订单备注</div>
            </el-col>
            <el-col class="input" :span="22">
              <div>
                <el-form-item>
                  <el-input
                    type="text"
                    placeholder="选填项,注意由快递员打印的订单备注只可打出20字"
                    maxlength="60"
                    height="100%"
                    show-word-limit
                    v-model.trim="textarea"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>
    <value-add @servicesType="servicesType" ref="valueAdd"></value-add>
    <footer>
      <div class="footer">
        <el-button type="success" class="footBtn" @click.prevent="submitKdy"
          >提交快递员打印</el-button
        >
        <el-button
          v-if="(maiServe == 'topay' || onlykdy) ? false : true"
          type='primary'
          class="footBtn"
          @click.prevent="directPrint"
          >立即打印</el-button
        >
        <el-button
          v-if="(maiServe == 'topay' || onlykdy) ? false : true"
          type="warning"
          class="footBtn"
          @click.prevent="waitPrint"
          >先存后打</el-button
        >
      </div>
    </footer>
    <div v-if="dialog" class="zMark">
      <el-dialog
        center
        top="50px"
        width="1000px"
        :title="dialog_title"
        :visible.sync="dialog"
        @close="closeDialog"
      >
        <div
          :style="{ height: address_type == 'editCollect' ? '320px' : '580px' }"
        >
          <v-address
            ref="collectList"
            v-if="address_type == 'collect'"
            :forCustmer="true"
          ></v-address>
          <v-send-address
            ref="sendList"
            v-if="address_type == 'send'"
          ></v-send-address>
        </div>
      </el-dialog>
    </div>
    <el-dialog
      title="请进行实名认证"
      :visible.sync="dialogFormVisible"
      center
      width="500px"
      id="IdCard"
      top="30vh"
    >
      <el-form
        :model="realForm"
        size="mini"
        :rules="IdCardRules"
        ref="IdCardForm"
      >
        <el-form-item label="姓名：" :label-width="formLabelWidth" prop="name">
          <el-input
            v-model.trim="realForm.name"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="身份证号："
          :label-width="formLabelWidth"
          prop="id"
        >
          <el-input
            v-model.trim="realForm.id"
            placeholder="证件号"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item
          label="证件类型："
          :label-width="formLabelWidth"
          prop="id"
        >
          <el-input
            v-model.trim="realForm.id"
            placeholder="证件号"
          ></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="realbtnShow">
        <el-button @click="dialogFormVisible = false" size="mini"
          >稍后验证</el-button
        >
        <el-button type="primary" @click="subReal" size="mini"
          >立即验证</el-button
        >
      </div>
    </el-dialog>
    <goods-picker
      :visible="showGoodsPicker"
      :initReceipt="true"
      @close="showGoodsPicker = false"
      @picked="handlePickGoods"
    />
  </div>
</template>
<script>
import vAddress from "@/components/address.vue";
import vSendAddress from "@/components/send_address.vue";
import myLocalStorage from "@/util/crypto.js";
import home from "@/api/home";
import util from "@/util/util";
import  myMinix  from '@/mixin/minix';
import goodsPicker from '@/components/goodsPicker.vue'
import Rule from '@/util/rule.js';
import print from '@/api/print'
import { mapGetters } from "vuex";
import valueAdd from '@/components/value_addservices.vue'
let sumbitType = 0;
let telReg = /^(400|800)(-)?[016789]\d{2}(-)?\d{4}$/g;
let ghReg = /^\d{3,4}(-)?\d{7,8}$/g;
let phoneReg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/g;
export default {
  name: 'customer',
  mixins: [myMinix],
  data() {
    return {
      daofu_amount: '',
      province: '',
      city: '',
      // block: '',
      select_type: 'send',
      save_btn: false,
      dialog_title: '选择寄件人',
      dialog: false,
      address_type: '', //选择地址类型
      first_click: true,
      isEdit: false,
      fieldCollect: [
        //收件验证字段
        'collect.name',
        'collect.phone',
        'collect.address',
        'collect.pca',
      ],
      fieldSend: [
        //寄件人验证字段
        'send.name',
        'send.phone',
        'send.address',
        'send.pca',
      ],
      typeArr: [
        { label: '文件', value: 0 },
        { label: '电子产品', value: 1 },
        { label: '办公/鞋服箱包', value: 2 },
        { label: '美妆日化', value: 3 },
        { label: '珠宝饰品', value: 4 },
        { label: '食品/保健/药品', value: 5 },
        { label: '工艺品', value: 6 },
        { label: '玩具乐器', value: 7 },
        { label: '其他', value: 8 },
      ],
      addserve: [
        { label: '寄付', value: 'pt' },
        { label: '到付', value: 'topay' },
      ],
      sender_address: [], // 寄件人地区选项配置
      typeContent: '', //物品类型
      maiServe: 'pt', //增值服务
      topayOnoff: false,
      textarea: '', //备注说明
      parcel_id: '', //包裹id
      Added_Collect: [], //已添加过的收件人
      isImport: false, // 编辑临时包裹
      ysdswitch: false,
      ysSwitch: false,
      print_btn: false,
      ruleForm: {
        send: {
          save_info: false, // 是否保存信息
          analysis: '', // 解析数据
          isAnalysis: false,
          name: '', // 姓名
          phone: '', // 手机号
          province: '', // 省
          province_code: '', //省编码
          city: '', // 市
          city_code: '', //市编码
          city_list: [], // 市列表数据
          area: '', //区
          area_code: '', //区编码
          area_list: [], //区列表
          address: '', // 详细地址
          pca: '', // 省市区
          address_id: 0, //
        },
        collect: {
          save_info: true, // 是否保存信息
          analysis: '', // 解析数据
          isAnalysis: false,
          name: '', // 姓名
          phone: '', // 手机号
          province: '', // 省
          province_code: '', //省编码
          city: '', // 市
          city_code: '', //市编码
          city_list: [], // 市列表
          area: '',
          area_code: '', //区编码
          area_list: [], //区列表
          address: '', // 详细地址
          pca: '', // 省市区
          type: '', //类型
          address_id: 0, //
        },
      },
      rules: Rule,
      Isprint: false,
      editcollectIndex: -1,
      package_count: 1,
      switchShow: false,
      anslsList: [],
      searchTimeout: '',
      dialogFormVisible: false,
      realForm: {
        name: '',
        id: '',
      },
      formLabelWidth: '100px',
      IdCardRules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        id: [{ required: true, message: '请输入身份证号', trigger: 'blur' }],
      },
      realFlag: false,
      addressClose: false,
      showGoodsPicker: false,
      onlykdy:false,
    }
  },
  computed: {
    ...mapGetters(['getFrom']),
    realbtnShow(){
      let flag = false
      if(this.realForm.id.indexOf("*") != -1){
        flag = false
      }else{
        flag = true
      }
      return flag
    },
  },
  components: {
    vAddress,
    vSendAddress,
    goodsPicker,
    valueAdd
  },
  created: function () {
    this.getCityData()
  },
  mounted() {
    window.q = this
    const oldonceNews = myLocalStorage.getItem('onceNews')
    if (oldonceNews) {
      const onceNews = JSON.parse(oldonceNews)
      this.ruleForm = Object.assign(this.ruleForm, onceNews.ruleForm)
      this.typeContent =
        onceNews.typeContent == ''
          ? util.getCookie('oldType') - 0
          : onceNews.typeContent - 0
      this.textarea = onceNews.textarea
      this.daofu_amount = onceNews.daofu_amount
      if(onceNews.morder_marking_infos){  //是否到付
        onceNews.morder_marking_infos.is_df == 1
        ? (this.maiServe = 'topay')
        : (this.maiServe = 'pt')
      }
      this.$nextTick(()=>{
        this.$refs.valueAdd.oncenews(onceNews.pri,onceNews.express_type,onceNews.morder_marking_infos,onceNews.onceNews||false)
      })
      this.idChecked()
    }else{
      this.$nextTick(()=>{
        this.$refs.valueAdd.init();
      })
    }
    if (this.$route.params.chooseRow) {
      const routeObj = JSON.parse(this.$route.params.chooseRow)
      this.ruleForm.collect.name = routeObj.name
      this.ruleForm.collect.phone = routeObj.phone
      this.ruleForm.collect.province = routeObj.province_name
      this.ruleForm.collect.province_code = routeObj.province_code
      this.ruleForm.collect.city = routeObj.city_name
      this.ruleForm.collect.city_code = routeObj.city_code
      this.ruleForm.collect.area = routeObj.district_name
      this.ruleForm.collect.area_code = routeObj.district_code
      this.ruleForm.collect.address = routeObj.address
      this.ruleForm.collect.pca = [
        routeObj.province_code,
        routeObj.city_code,
        routeObj.district_code,
      ]
    }
    if (this.$store.state.bindKdy == 10 || this.$store.state.bindKdy == 12) {
      this.addserve = [{ label: '寄付', value: 'pt' }]
    }
  },
  methods: {
    inputClear(type){
      this.ruleForm[type].analysis = ''; // 解析数据
      this.ruleForm[type].isAnalysis = false;
      this.ruleForm[type].name = '';// 姓名
      this.ruleForm[type].phone = '';// 手机号
      this.ruleForm[type].province =  ''; // 省
      this.ruleForm[type].province_code =  ''; //省编码
      this.ruleForm[type].city =  ''; // 市
      this.ruleForm[type].city_code =  ''; //市编码
      this.ruleForm[type].city_list =  []; // 市列表
      this.ruleForm[type].area =  '';
      this.ruleForm[type].area_code =  ''; //区编码
      this.ruleForm[type].area_list =  []; //区列表
      this.ruleForm[type].address =  '';// 详细地址
      this.ruleForm[type].pca =  ''; // 省市区
      this.ruleForm[type].type =  '';//类型
      this.ruleForm[type].status_desc =  '';
      this.ruleForm[type].address_id =  0; 
    },
    servicesType(val){
      this.onlykdy = val
    },
    //失焦判断
    checkDizhi() {
      const {
        address,
        province_code,
        city_code,
        area_code,
        province,
        city,
        area,
      } = this.ruleForm.collect
      if (province_code && city_code && area_code && address) {
        const checkQuery = [
          {
            index: 0,
            receiver_province: province,
            receiver_city: city,
            receiver_district: area,
            receiver_address: address,
            sender_province: this.ruleForm.send.province,
            sender_city: this.ruleForm.send.city,
            sender_district: this.ruleForm.send.district,
            sender_address: this.ruleForm.send.address,
          },
        ]
        home.checkaddress(this, checkQuery).then((res) => {
          if (res.success) {
            res.data[0].status_desc != '正常'
              ? (this.addressClose = true)
              : (this.addressClose = false)
          }
        })
      } else {
        this.addressClose = false
      }
    },
    moneyInput(value) {
      const newVal = value.replace(/[^\d.]/g, '')
      if (newVal > 0 && newVal < 10000) {
        this.daofu_amount = newVal
      }
      if (newVal <= 0) {
        this.daofu_amount = ''
      }
      if (newVal >= 10000) {
        this.daofu_amount = 9999 + '.00'
      }
    },
    moenyBlur() {
      if (this.daofu_amount > 0) {
        this.daofu_amount = (this.daofu_amount - 0).toFixed(2)
      } else {
        this.daofu_amount = ''
      }
    },
    // 查询暂时身份信息 并监听
    idChecked() {
      const query = {
        sender_name: this.ruleForm.send.name,
        sender_phone: this.ruleForm.send.phone,
      }
      const idFlag =
        query.sender_phone.length <= 16 &&
        (telReg.test(query.sender_phone) ||
          phoneReg.test(query.sender_phone) ||
          ghReg.test(query.sender_phone))
      if (!query.sender_name && !idFlag) {
        console.log(
          '条件缺失',
          query,
          telReg.test(query.sender_phone),
          phoneReg.test(query.sender_phone),
          ghReg.test(query.sender_phone)
        )
      } else {
        home.saveIdinfo(this, query).then((res) => {
          if (res.success && res.data) {
            this.realFlag = true
            this.realForm = {
              name: res.data.name,
              id: res.data.id_card,
            }
          } else {
            this.realFlag = false
            this.realForm = {
              name: '',
              id: '',
            }
          }
        })
      }
    },
    //身份证验证
    subReal() {
      this.$refs.IdCardForm.validate((valid) => {
        if (valid) {
          home.Idvalidate(this).then((res) => {
            if (res.success) {
              this.realFlag = true
              this.dialogFormVisible = false
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    querySearch(queryString, cb, addressType) {
      home.lxAddress(this, queryString, addressType).then((res) => {
        var restaurants = []
        if (res.success) {
          restaurants = res.data.map((el) => {
            return {
              value:
                el.name +
                ' ' +
                el.phone +
                ' ' +
                el.province_name +
                ' ' +
                el.city_name +
                ' ' +
                el.district_name +
                ' ' +
                el.address,
              id: el.id,
              name: el.name,
            }
          })
        }
        var results = queryString
          ? restaurants.filter(this.createFilter(queryString))
          : restaurants
        // 调用 callback 返回建议列表的数据
        clearTimeout(this.timeout)
        this.searchTimeout = setTimeout(() => {
          cb(results)
        }, 3000 * Math.random())
      })
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        )
      }
    },
    handleSelect(item, type) {
      home.getAddressById(this, item.id).then((res) => {
        if (res.success) {
          const result = res.data
          this.ruleForm[type] = {
            name: result.name,
            phone: result.phone,
            province: result.province_name,
            province_code: result.province_code,
            city: result.city_name,
            city_code: result.city_code,
            area: result.district_name,
            area_code: result.district_code,
            address: result.address,
            pca: [result.province_code, result.city_code, result.district_code], // 省市区
          }
        }
      })
    },
    //选择到付提示
    serveChoose(val) {
      if (val == 'pt') {
        this.daofu_amount = ''
      }else{
        const {bj_switch,ds_switch,qd_switch} = this.$refs.valueAdd 
        if(bj_switch){
          util.gj_message('到付单不支持保价')
          this.maiServe = 'pt'
          return
        }
        if(ds_switch){
          util.gj_message('到付单不支持代收货款')
          this.maiServe = 'pt'
          return
        }
        if(qd_switch){
          util.gj_message('到付单不支持签单返回')
          this.maiServe = 'pt'
          return
        }
      }
    },
    //查询是否有到付权限
    getdfAuth() {
      const Istopay = util.getJsonValues(this.$store.state.commondict,'exvaluelist')
      if(!JSON.parse(Istopay)){
        this.addserve = [{ label: '寄付', value: 'pt' }]
      }else{
        this.addserve = [
          { label: '寄付', value: 'pt'},
          { label: '到付', value: 'topay'},
        ]
      }
      // home.addAuth(this).then((res) => {
      //   if (res.success && res.data.topay) {
      //     this.topayOnoff = true
      //   }
      // })
    },
    typeChoose(val) {
      this.typeContent = val
    },
    switchTip(val) {
      if (val) {
        this.package_count = 2
      } else {
        this.package_count = 1
      }
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1)
      var vars = query.split('&')
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=')
        if (pair[0] == variable) {
          return pair[1]
        }
      }
      return false
    },
    /** 提交协议快递员 */
    submitKdy() {
      sumbitType = 1
      this.changeTrigger('change')
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.save_btn = true
          if (this.$store.state.bindKdy == 10) {
            this.$message.warning(
              '您当前未与快递员建立协议关系，无法提交快递员打印'
            )
            return
          }
          this.createParcel()
        } else {
          this.$message.error('订单信息填写有误，请查看重新填写')
          return false
        }
      })
    },
    /** 直接打印 */
    directPrint() {
      const { lodopStatus, WebSocketstatus, name } =
        this.$store.state.connetStatus
      if (!lodopStatus || !WebSocketstatus || !name) {
        this.$printError(true)
        return
      }

      this.changeTrigger('change')
      this.Isprint = true
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.save_btn = true
          this.createParcel('printing')
        } else {
          this.$message.error('订单信息填写有误，请查看重新填写')
          return false
        }
      })
    },
    /** 稍后打印 */
    waitPrint() {
      sumbitType = 0;
      this.Isprint = false;
      this.changeTrigger('change')
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.save_btn = true
          this.createParcel()
        } else {
          this.$message.error('订单信息填写有误，请查看重新填写')
          return false
        }
      })
    },
    //获取实名
    getReal() {
      let that = this
      const sender = this.ruleForm.send
      const query = {
        sender_name: sender.name,
        sender_phone: sender.phone,
      }
      return new Promise((resolve, reject) => {
        home.saveIdinfo(that, query).then((res) => {
          if (res.success) {
            if (res.data) {
              that.realFlag = true
              ;(that.realForm = {
                name: res.data.name,
                id: res.data.id_card,
              }),
                resolve({
                  success: true,
                })
            } else {
              resolve({
                success: false,
              })
            }
          }
        })
      })
    },
    getCityData() {
      this.sender_address = this.ysbAddressFile.getcity()
    },

    /** 遍历地址 */
    forAddress(type) {
      let data = this.ruleForm[type]
      let res = []
      cityData.cityData.forEach((item) => {
        if (item.label == data.province) {
          res = [...res, item.value]
          item.children.forEach((ite) => {
            if (ite.label == data.city) {
              res = [...res, ite.value]
              ite.children.forEach((it) => {
                if (it.label == data.area) {
                  res = [...res, it.value]
                }
              })
            }
          })
        }
      })
      this.ruleForm[type].pca = res
    },
    /**关闭对应的Dialog */
    closeDialog() {
      this.dialog = false
    },

    /** 地址解析 */
    doAnalysis(analysis, type) {
      console.log(analysis, type)
      let self = this
      // if (!self.ruleForm[type].analysis) {
      //   self.$message({
      //     type: "warning",
      //     message: "请填写解析内容",
      //   });
      //   return;
      // }
      // self.ruleForm[type].isAnalysis = true;
      home
        .doAnalysis(self, analysis)
        .then((res) => {
          self.ruleForm[type].isAnalysis = false
          if (res.success) {
            if (res.data.length == 1) {
              let data = res.data[0]
              self.ruleForm[type].pca = [
                data.province_code,
                data.city_code,
                data.district_code,
              ]
              self.ruleForm[type].name = data.name || ''
              self.ruleForm[type].phone = data.phone || ''
              self.ruleForm[type].province = data.province_name || ''
              self.ruleForm[type].city = data.city_name || ''
              self.ruleForm[type].area = data.district_name || ''
              self.ruleForm[type].province_code = data.province_code || ''
              self.ruleForm[type].city_code = data.city_code || ''
              self.ruleForm[type].area_code = data.district_code || ''
              self.ruleForm[type].address = data.address || ''
              self.checkDizhi()
              if (type == 'send') self.idChecked()
            }
            if (res.data.length > 1) {
              this.anslsList = res.data
              this.fitInit()
            }
          }
        })
        .catch((rej) => {
          console.log(rej)
          // self.ruleForm[type].isAnalysis = false;
        })
    },
    /**前置判断 */
    createParcel() {
      if (this.typeContent === '') {
        this.$message.error('请选择物品类型')
        return
      }
      if(!this.$refs.valueAdd.value_checkRrror()){
         return  
      }
      if (!this.realFlag) {
        this.dialogFormVisible = true
        this.$message.error('请先进行实名认证')
        return
      }
      let words = [
        { index: 0, origin_words: util.trimAll(this.textarea) },
        { index: 1, origin_words: util.trimAll(this.ruleForm.send.address) },
        { index: 2, origin_words: util.trimAll(this.ruleForm.collect.address) },
      ]
      home.sensitivewords(this, words).then((res) => {
        if (res.success) {
          const resultArr = res.data
          let filwordsArr = resultArr.filter(
            (el) => el.origin_words != el.sensitive_words
          )
          if (filwordsArr.length) {
            this.textarea = resultArr[0].sensitive_words
            this.ruleForm.send.address = resultArr[1].sensitive_words
            this.ruleForm.collect.address = resultArr[2].sensitive_words
            this.$confirm(
              '您输入的信息中含有敏感词请修改后重新操作点击忽略订单中将以“□”代替',
              '提示',
              {
                confirmButtonText: '忽略',
                cancelButtonText: '去修改',
                type: 'warning',
              }
            )
              .then(() => {
                this.tingfa_jg()
              })
              .catch(() => {})
          } else {
            this.tingfa_jg()
          }
        }
      })
    },
    tingfa_jg() {
      if (this.addressClose) {
        let tingfa = { content: '', ok: '继续保存', cacel: '再考虑下' }
        if (this.Isprint) {
          tingfa.content =
            '此订单暂时存在“网点停发”情况,无法获取运单号,是否保存订单到待打印中'
        } else {
          if (sumbitType == 1) {
            tingfa.content =
              '此订单暂时存在“网点停发”情况，无法提交快递员，是否保存订单到待打印中'
          } else {
            tingfa.content =
              '此订单暂时存在“网点停发”情况，是否继续保存订单到待打印中'
          }
        }
        this.$confirm(tingfa.content, '提示', {
          confirmButtonText: tingfa.ok,
          cancelButtonText: tingfa.cacel,
          type: 'warning'
        }).then(() => {
          this.faceLesswarn()
        }).catch(() => {         
        });
      }else{
        this.faceLesswarn()
      }
    },
    //面单不足提醒
    async faceLesswarn(){
      let result = await print.ywyauthorize()
      if(this.Isprint || sumbitType == 1){ //打印或提交快递员
        if(!result.success){
          const data = result.data;
          if(data.code == 9003){ //面单授权未开启
            if([1,2].includes(data.data.team_role)){  //团长或个人
              this.$toast(true,{
                title:'面单授权未开启',
                htmlstring:'<div>当前面单授权未开启，请联系合作快递员</div>'+
                '<div>“'+data.data.ywy_name+'”确定授权状态</div>'+
                '<div>快递员电话：'+data.data.ywy_phone+'</div>'
              },'ywyauthorize',()=>{
                // this.createActions()
              })
            }else{ //团员
              this.$toast(true,{
                title:'面单授权未开启',
                htmlstring:'<div>当前面单授权未开启，请尽快联系团长</div>'+
                '<div>向合作快递员确定授权状态</div>'
              },'ywyauthorize',()=>{
                // this.createActions()
              })
            }
          }else if(data.code == 9004){ //面单余额不足
            if([1,2].includes(data.data.team_role)){  //团长或个人
              this.$toast(true,{
                title:'面单余量过低提醒',
                htmlstring:'<div>当前剩余单量'+data.data.left_value+'单，请联系合作快递员</div>'+
                '<div>“'+data.data.ywy_name+'”充值面单</div>'+
                '<div>快递员电话：'+data.data.ywy_phone+'</div>'
              },'ywyauthorize',()=>{
                this.createActions()
              })
            }else{ //团员
              this.$toast(true,{
                title:'面单余量过低提醒',
                htmlstring:'<div>当前剩余单量'+data.data.left_value+'单，请尽快联系团长</div>'+
                '<div>充值面单</div>'
              },'ywyauthorize',()=>{
                this.createActions()
              })
            }
          }else{
           this.$message.error('查询面单余量失败code-'+ data.code)
          }
        }else{
          this.createActions()
        }
      }else{
        this.createActions()
      }
    },
    //下单交互
    createActions() {
      if (this.first_click) {
        this.first_click = false
        const sender = this.ruleForm.send
        const receiver = this.ruleForm.collect
        let val_addObj = this.$refs.valueAdd.besure()
        let query = {
          account_id: util.getCookie('account_id'),
          name: this.realForm.name,
          id_card: this.realForm.id,
          item_note: this.textarea,
          value_add_type: this.maiServe,
          package_count: this.package_count,
          item_type: this.typeContent,
          daofu_amount: this.daofu_amount,
          source: 14,
          express_type:val_addObj.zc_switch ? "TK" : "PK", //智橙网服务
          pri:val_addObj.ys_switch ? "PRI" : '', // 隐私面单
          marking_infos:val_addObj.marking_infos, //保价，代收货款，签收统计等增值服务
          order_address_data: {
            order_receiver_address_data_list: [
              {
                receiver_address: receiver.address,
                receiver_city: receiver.city,
                receiver_city_code: receiver.city_code,
                receiver_district: receiver.area,
                receiver_district_code: receiver.area_code,
                receiver_name: receiver.name,
                receiver_phone: receiver.phone,
                receiver_province: receiver.province,
                receiver_province_code: receiver.province_code,
                address_id: receiver.address_id,
              },
            ],
            sender_address: sender.address || '',
            sender_city: sender.city || '',
            sender_city_code: sender.city_code || '',
            sender_district: sender.area || '',
            sender_district_code: sender.area_code || '',
            sender_name: sender.name || '',
            sender_phone: sender.phone || '',
            sender_province: sender.province || '',
            sender_province_code: sender.province_code || '',
            address_id: sender.address_id,
          },
        }
        if (this.ruleForm.send.save_info) {
          home.CreateAddress(this, 'send', 'S')
        }
        if (this.ruleForm.collect.save_info) {
          home.CreateAddress(this, 'collect')
        }
        if (this.Isprint) {
          this.Isprint = false
          query.template_platform = 'lodop'
          home.agentPrint(this, query).then((res) => {
            if (res.success) {
              myLocalStorage.removeItem('onceNews')
              this.$message.success(
                '打印信息已成功提交至' +
                  util.getCookie('defult_print') +
                  '打印,若打印机长时间不出纸，可以F5刷新浏览器后再次操作'
              )
              setTimeout(() => {
                this.$parent.$refs.menuNav.goPath(3, '/printed')
                this.first_click = true
                this.save_btn = false
              }, 1000)
            } else {
              if (
                ~~res.data.code == 7010 ||
                ~~res.data.code == 7013 ||
                ~~res.data.code === 7011 ||
                ~~res.data.code === 7012 ||
                ~~res.data.code === 7018 ||
                ~~res.data.code === 7019
              ) {
                myLocalStorage.removeItem('onceNews')
                setTimeout(() => {
                  this.$parent.$refs.menuNav.goPath(2, '/waitPrinted')
                  this.first_click = true
                  this.save_btn = false
                }, 1000)
              } else {
                this.first_click = true
                this.save_btn = false
              }
            }
          })
        } else {
          if (sumbitType == 1) {
            //提交快递员
            home.orderToywy(this, query).then((res) => {
              if (~~res.success) {
                myLocalStorage.removeItem('onceNews')
                this.$message.success('提交快递员成功!')
                setTimeout(() => {
                  this.first_click = true
                  this.save_btn = false
                  this.$parent.$refs.menuNav.goPath(2, '/waitPrinted')
                }, 1000)
              } else {
                if (
                  ~~res.data.code == 7010 ||
                  ~~res.data.code == 7013 ||
                  ~~res.data.code === 7011 ||
                  ~~res.data.code === 7012 ||
                  ~~res.data.code === 7018 ||
                  ~~res.data.code === 7019
                ) {
                  myLocalStorage.removeItem('onceNews')
                  setTimeout(() => {
                    this.$parent.$refs.menuNav.goPath(2, '/waitPrinted')
                  }, 1000)
                }
                this.first_click = true
                this.save_btn = false
              }
            })
          } else {
            home.orderForwait(this, query).then((res) => {
              if (~~res.success) {
                myLocalStorage.removeItem('onceNews')
                this.$message.success('保存成功!')
                setTimeout(() => {
                  this.first_click = true
                  this.save_btn = false
                  this.$parent.$refs.menuNav.goPath(2, '/waitPrinted')
                }, 1000)
              } else {
                if (
                  ~~res.data.code == 7010 ||
                  ~~res.data.code == 7013 ||
                  ~~res.data.code === 7011 ||
                  ~~res.data.code === 7012 ||
                  ~~res.data.code === 7018 ||
                  ~~res.data.code === 7019
                ) {
                  myLocalStorage.removeItem('onceNews')
                  setTimeout(() => {
                    this.$parent.$refs.menuNav.goPath(2, '/waitPrinted')
                  }, 1000)
                }
                this.first_click = true
                this.save_btn = false
              }
            })
          }
        }
      } else {
        this.$message({
          type: 'warning ',
          message: '单击次数过快，请稍后再试',
        })
        return
      }
    },
    /** 选择地址 */
    selectAddress(type) {
      this.address_type = type
      if (type == 'send') {
        this.dialog_title = '选择寄件人'
      } else {
        this.dialog_title = '选择收件人'
        setTimeout(() => {
          this.$refs.collectList.$refs.multipleTable.clearSelection()
        }, 100)
      }
      this.dialog = true
    },
    /**输入其他物品类型 */
    inputOther() {
      this.$prompt('请输入品类', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.{0,10}$/,
        inputErrorMessage: '物品类型不能超过十个字符',
      })
        .then(({ value }) => {
          this.typeContent = value
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入',
          })
          this.typeContent = ''
        })
    },

    /**改变校验规则触发状态 */
    changeTrigger(status) {
      this.rules['collect.name'][0].trigger = status
      this.rules['collect.phone'][0].trigger = status
      this.rules['collect.address'][0].trigger = status
      this.rules['collect.province'][0].trigger = status
      this.rules['collect.city'][0].trigger = status
      this.rules['collect.area'][0].trigger = status
    },

    /**checkFiled */
    checkFiled() {
      if (
        this.ruleForm.collect.name ||
        this.ruleForm.collect.phone ||
        this.ruleForm.collect.address ||
        this.ruleForm.collect.province ||
        this.ruleForm.collect.city ||
        this.ruleForm.collect.area ||
        this.ruleForm.collect.pca.length
      ) {
        return true
      } else {
        this.$refs.ruleForm.clearValidate(this.fieldCollect)
        return false
      }
    },

    /**重置字段 */
    restFiled() {
      this.ruleForm.collect.name = ''
      this.ruleForm.collect.phone = ''
      this.ruleForm.collect.province = ''
      this.ruleForm.collect.area = ''
      this.ruleForm.collect.city = ''
      this.ruleForm.collect.address = ''
      this.ruleForm.collect.pca = ''
      this.ruleForm.collect.area_code = ''
      this.ruleForm.collect.province_code = ''
      this.ruleForm.collect.city_code = ''
    },

    /**取消 */
    cancel() {
      this.$router.go(-1) //返回上一层
    },

    /** 解析绑定地址 */
    changeAddress(type) {
      if (!type) return
      let address = this.$refs[type].getCheckedNodes()[0].pathLabels // 地址显示
      let code = this.$refs[type].getCheckedNodes()[0].path // 地区编码
      this.ruleForm[type].province = address[0]
      this.ruleForm[type].province_code = code[0]
      this.ruleForm[type].city = address[1]
      this.ruleForm[type].city_code = code[1]
      this.ruleForm[type].area = address[2]
      this.ruleForm[type].area_code = code[2]
    },

    handlePickGoods(goods, keep = false) {
      this.typeContent = goods
      this.showGoodsPicker && (this.showGoodsPicker = keep)
    },
  },
}
</script>

<style lang="stylus" scoped>
.inputClear{
  position: absolute;
  right: 10px;
  top: 40px;
}
.home {
  padding-bottom: 90px;

  .forsign{
    display: flex;
    justify-content: flex-start;
    border-bottom: 1px solid #e8e8e8;
    height: 50px;
    padding: 0 40px;
    line-height: 50px;
    >div{
      margin-right 30px
      cursor: pointer;
      span{
        color #fabe00;
      }
    }
  }
  .model {
    background: #fff;
    border-radius: 4px;

    ._header {
      height: 50px;
      padding: 0 40px;
      border-bottom: 1px solid #E8E8E8;

      .left {
        float: left;
        line-height: 50px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(33, 33, 33, 1);
        display: flex;
        align-items: center;

        img {
          width: 20px;
          height: 28px;
          vertical-align: middle;
          margin-right: 10px;
        }
      }

      .right {
        line-height: 50px;
        font-weight: 400;
        color: rgba(28, 139, 246, 1);
        display: flex;
        align-items: center;
        justify-content: flex-end;

        a {
          font-size: 14px;
          color: #1C8BF6;
        }

        img {
          width: 10px;
          height: 10px;
          vertical-align: middle;
          margin-right: 10px;
        }
      }
    }

    .from {
      padding: 20px 40px 0px 40px;

      .flexEnd{
        display flex;
        justify-content: flex-end
      }

      >.el-row {
        margin-bottom: 20px;
      }
      .collectBox{
        background: #f5f5f5;
        padding: 20px 0 20px 0;
        border-radius: 9px;
        >.el-row {
          margin-bottom: 20px;
        }
        .flexBetween{
          display: flex;
          justify-content: space-between;
        }
      }
      .el-row {
        display: flex;
        align-items: center;
        font-size: 14px;

        .title {
          text-align: right;
          margin-right: 10px;
          color: #212121;
          font-size:13px;
        }
        font{
          font-size:12px;
          color:#888888;
        }

        .input {
          /deep/ .el-form-item {
            margin-bottom: 0;

            .el-input {
              width: 97%;
              float: left;
            }

            /deep/ .el-form-item__content {
              margin: 0 !important;
            }
          }

          .el-cascader,.el-autocomplete {
            width: 97%;
            float: left;

            // margin-right:10px;
            /deep/.el-input {
              width: 100% !important;
            }
          }

          .el-select {
            width: 97%;
            float: left;

            /deep/.el-input {
              width: 100% !important;
            }
          }

          .span {
            color: #FF0000;
            font-size: 14px;
            float: right;
          }
        }
      }

      .checkbox {
        margin-left: 110px;
        font-size:13px;
      }

      .parse {
        background: #1C8BF6;
        color: #fff;
        border-radius: 0 4px 4px 0;
      }
    }
  }

  .addressee {
    margin-top: 0px;

    .collect-list {
      height: 40px;
      display: flex;
      align-items: center;
      padding: 0 20px;
      background: rgba(28, 139, 246, 0.1);
      border-radius: 4px;
      color: #212121;
      justify-content: space-between;

      .left {
        flex: 1;
        display: flex;
        align-items: center;

        .rod {
          display: inline-block;
          width: 15px;
          height: 15px;
          border: 1px solid #333;
          border-radius: 100%;
          font-size: 12px;
          line-height: 17px;
          text-align: center;
          margin-right: 10px;
        }
      }

      .right {
        flex-basis: 60px;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        img {
          width: 20px;
          height: 20px;
          cursor: pointer;
          margin-left: 15px;
        }
      }
    }
  }

  .other {
    .el-select {
      width: 100%;
    }

    .from {
      padding-top: 10px;
    }

    .from > .el-row {
      margin-bottom: 0px;
    }

    .from .el-row {
      align-items: flex-start;

      .title {
        margin-top: 10px;
      }
    }

    .el-textarea {
      height: 100px;

      /deep/ .el-textarea__inner {
        height: 100%;
      }
    }
  }

  footer {
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 40px;
    line-height: 40px;
    text-align: center;
    box-shadow: 1px 0 7px rgba(0, 0, 0, 0.1);
    z-index:99
    .footBtn{
        width 150px
        margin-right 50px
        padding 8px 10px
    }
  }

  /deep/.el-textarea textarea {
    resize: none;
  }

  .home .other .el-textarea .el-textarea__inner {
    resize: none;
  }

  /deep/.el-textarea .el-input__count {
    line-height: 20px;
  }

  /deep/.el-form-item__content {
    margin-left: 0 !important;
  }
}
.forExample{
  display: flex;
  justify-content: flex-start;
  padding: 10px 0;
  font-size: 12px;
  color: #909399;
  .left{
    width 40px
    text-align left
  }
  .right{
    flex 1
  }
}
.cp_title{
  padding 10px 0;
  color #E6A23C;
  span{
    color #F56C6C
  }
}
.errorTip{
  color:#F56C6C
}
.ListItem span{
  padding-right:5px;
}
.flexEnd{
  padding-top 10px;
  display flex;
  justify-content: flex-end
}
#IdCard /deep/.el-form-item__content{
  margin-left: 100px !important;
}
.realBox{
  cursor: pointer;
  border: 1px solid #C0C4CC;
  height: 36px;
  line-height: 36px;
  text-align:right;
  padding:0 15px;
  border-radius: 4px;
}
</style>
